export default {
  title01: "Cuaca Saat Ini",
  title02: "24 Jam",
  title03: "RAMALAN 10 HARI",
  title04: "AQI",
  title05: "Informasi Selengkapnya",
  title06: "Terbit dan Terbenam",
  title07: "Fase Bulan",
  title08: "Bulan Purnama Berikutnya",
  title09: "Bulan Baru Berikutnya",
  title10: "Siang",
  title11: "Malam",
  title12: "Matahari Terbit",
  title13: "Matahari Terbenam",
  title14: "Bulan Terbit",
  title15: "Bulan Terbenam",
  title16: "Sumber",
  title17: "Mulai",
  title18: "Berakhir",
  title19: "Gunakan Lokasi Saat Ini",
  title20: "Cari Kota",
  title21: "Suhu Sebenarnya",
  title22: "Suhu di Tempat Teduh",
  title23: "Sekarang",
  title24: "Hari Ini",
  title25: "Minggu",
  title26: "Senin",
  title27: "Selasa",
  title28: "Rabu",
  title29: "Kamis",
  title30: "Jumat",
  title31: "Sabtu",
  title32: "Memuat...",
  title33: "Sekarang",
  title34: "Per Jam",
  title35: "Harian",
  title36: "Matahari & Bulan",
  title37: "Kualitas Udara",
  title38: "Kontak: xif550402@gmail.com",
  title39: "Perjanjian Privasi",
  title40: "Copyright @ comfortweather.com 2020 - 2026. Semua Hak Dilindungi.",
  title41: "Data disediakan oleh",
  title42: "Tinggi",
  title43: "Rendah",
  title44: "Setuju",
  title45:
    "Terima kasih telah menggunakan ComfortWeather! Untuk melindungi hak dan kepentingan hukum Anda dengan lebih baik, harap baca dengan saksama ",
  title46: "Kebijakan Privasi",
  title47: " sebelum menggunakan.",
  title48: "",
  title49: "Kontak: xyjph123@gmail.com",
  title50: "Copyright @ 24hweather.com 2020 - 2026. Semua Hak Dilindungi.",
  title51:
    "Terima kasih telah menggunakan 24hweather! Untuk melindungi hak dan kepentingan hukum Anda dengan lebih baik, harap baca dengan saksama ",
  title52: "Lokasi Anda telah berubah. Apakah Anda ingin memperbaruinya?",
  title53: "Konfirmasi",
  title54: "Batal",
  title55: "Kembali",
  title56: "Berita",
  title57: "Memperbarui Cuaca…",
  title58: "Cuaca Telah Diperbarui",
  title59: "Tampilkan Semua",
  title60: "Copyright @ mobi321.com 2020 - 2026. Semua Hak Dilindungi.",
  title61: "Kemarin",
  title62: "Besok",
  title63: "RAMALAN 15 HARI",
  title64: "Detail hari ini",
  title65: "Rahu Kaal",
  title66: "Indeks Gaya Hidup",
  title67: "Indeks Gaya Hidup",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Sulit kering",
  title103: "Lambat kering",
  title104: "Cukup cepat kering",
  title105: "Cepat kering",
  title106: "Sangat cepat kering",

  title107: "Tidak cocok",
  title108: "Cukup menyenangkan",
  title109: "Menyenangkan",
  title110: "Sangat cocok",
  title111: "Kondisi sempurna",

  title112: "Kondisi sehat",
  title113: "Kondisi normal",
  title114: "Potensi risiko ringan",
  title115: "Risiko tinggi",
  title116: "Risiko sangat tinggi",

  title117: "Tidak cocok",
  title118: "Cukup cocok",
  title119: "Mendukung",
  title120: "Sangat cocok",
  title121: "Kondisi sempurna",

  title122: "Sangat kering",
  title123: "Cenderung kering",
  title124: "Sedikit kering",
  title125: "Tidak terlalu kering",
  title126: "Sangat kecil berpotensi kering",

  title127: "Tidak disarankan",
  title128: "Cukup baik",
  title129: "Hari baik",
  title130: "Kondisi sangat baik",
  title131: "Kondisi sangat ideal",
};
